import { EntityType } from '@/plugins/cad/module/CADModule/model/common/constant'
import type { IPoint } from '@/plugins/cad/module/CADModule/model/common/interface'
import { BaseEntity } from './BaseEntity'

/** 填充类型 */
export enum FillType {
  /** 实心填充 */
  Solid = 'Solid',
  /** 图案填充 */
  Pattern = 'Pattern',
  /** 渐变色填充 */
  Gradient = 'Gradient',
}

/** 填充实体 */
export class HatchEntity extends BaseEntity {
  /** 填充图案角度（弧度） */
  patternAngle: number = 0
  /** 填充图案缩放比例 */
  patternScale: number = 1
  /** 填充类型 */
  fillType: FillType = FillType.Solid
  /** 图案填充时的图案名称 */
  patternName?: string

  /** 渐变色填充时的渐变名称 */
  gradientName?: string
  /** 渐变色起始颜色 */
  gcolor1?: number
  /** 渐变色结束颜色 */
  gcolor2?: number

  /** 是否与多边形关联 */
  associative: boolean = false

  /** 外轮廓环：key -> 实体列表 */
  loops: Record<string, BaseEntity[]> = {}
  /** 孔洞环：key -> 实体列表 */
  holes: Record<string, BaseEntity[]> = {}

  /** 填充平面原点（用于图案对齐） */
  startPoint!: IPoint
  /** 填充平面 X 方向（用于图案旋转） */
  xDirection!: IPoint

  protected serializeKeys: string[] = [
    'patternAngle',
    'patternScale',
    'fillType',
    'patternName',
    'gradientName',
    'gcolor1',
    'gcolor2',
    'associative',
    'loops',
    'holes',
    'startPoint',
    'xDirection',
  ]

  constructor(data: Partial<HatchEntity>) {
    super(EntityType.Hatch)
    Object.assign(this, data)
  }
}
